import React from 'react'

import { MdPlayArrow } from "react-icons/md";

const ClinicalEvidence = () => {
    return (
        <>
            

           
        </>
    )
}

export default ClinicalEvidence
